module.exports = __webpack_public_path__ + "img/89.a3befcb0.jpg";